import type { FC } from 'react';
import { useContext } from 'react';

import { RiskDescriptions } from '@src/common-components/risk-descriptions';
import { Store } from '@src/store';

export const IFLHouseRiskDescriptions: FC = () => {
  const {
    state: {
      stateFormIFLHouse: { risks, risksPage },
    },
  } = useContext(Store);

  return <RiskDescriptions risks={risks} risksPage={risksPage} />;
};
